"use client";

import { useEffect } from "react";
import { initClientErrorCapture } from "@/lib/errors/client";

// Tiny client-only component that boots the global error / breadcrumb
// listeners. Mounted once at the root layout, inside the ErrorBoundary
// so a render-time crash here doesn't take the whole tree.
export function ClientErrorInit() {
  useEffect(() => {
    initClientErrorCapture();
  }, []);
  return null;
}
